import { Play } from 'lucide-react';

import { cn } from '@/lib/utils';

const buttonClasses =
  'flex items-center gap-2 font-medium decoration-primary border-b-2 border-primary pb-1 text-base';

export const FooterTagline = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex gap-6 items-start md:items-center', className)}>
      <span className="pb-1 text-base text-pretty">
        Build <span className="font-semibold">better</span> software,{' '}
        <span className="italic">faster</span> with FlagSync.
      </span>

      <div className="flex items-center gap-6 flex-shrink-0">
        <div className="flex items-center gap-2">
          <a href="/register">
            <span className={buttonClasses}>
              <span>Get Started</span>
              <Play fill="#00D68E" className="text-primary w-4 h-4" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};
